import { render } from "./staff-setting.vue?vue&type=template&id=02fecb66"
import script from "./staff-setting.vue?vue&type=script&lang=js"
export * from "./staff-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__